import { MeetingRoom } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery } from "@mui/material";
import moment from "jalali-moment";

import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Link, useLocation } from "react-router-dom";
import DarkModeSwitch from "../../../shared/ui/common/darkModeSwitch.jsx";
import { baseUrl, DOWNLOAD_FILE } from "../../../shared/api/endpoints.js";
import { openDrawer } from "../../../shared/state/slices/menu.js";
import { readStoredObject } from "../../../shared/state/storage";
import DrawerListItem from "./DrawerListItem.jsx";
const Sidebar = ({ headerMenu, viewALl, setViewALl }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [hover, setHover] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [userInfo, setuserInfo] = useState({});
  const { themeColor } = useSelector((state) => state.themeColor);
  const { companyInfo } = useSelector((state) => state.relationals);

  var dark = themeColor === "dark";
  useEffect(() => {
    if (localStorage.getItem("s")) {
      setuserInfo(readStoredObject("s") || {});
    }
  }, [localStorage.getItem("s")]);
  const styles = {
    innerBox: {
      padding: "14px 0px 14px 24px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      maxHeight: "calc(100vh - 50px)",
      overflowY: "overlay",
      height: "100%",
    },
    logo: {
      height: "1.25rem",
      fill: (theme) =>
        theme.palette.mode === "light" ? "rgba(179, 179, 184, 1)" : "#fff",
    },
    listItem: {
      cursor: "pointer",
      width: { md: "12.1875rem" },
      paddingRight: "0",
      paddingLeft: "0",
    },
    listItemIcon: {
      fontSize: "1.25rem",
      color: (theme) =>
        theme.palette.mode === "light" ? "rgba(162, 162, 168, 0.81)" : "#fff",
    },
    listItemText: {
      textAlign: "left",
      color: (theme) =>
        theme.palette.mode === "light" ? "rgba(0, 0, 0)" : "#fff",
      opacity: viewALl || hover ? 1 : 0,
      transition: "all 450ms ease",
    },
  };
  const isMd = useMediaQuery("(min-width:900px)");
  const logout = () => {
    localStorage.clear();
    document.location.href = "/";
  };
  return (
    <Box
      component="aside"
      sx={{
        width: viewALl || hover ? { md: "13.75rem", xs: "80%" } : "4rem",
        bgcolor: "background.paper",
        /*   background:"linear-gradient(to left, #09203F,#0D324D )", */
        /*   background:
          "url(/images/6350b12067f74deccb283957f7a5f091.jpg) no-repeat left", */

        /*    paddingTop: "10px", */
        boxShadow: " -4px 5px 29px rgb(0 0 0 / 16%)",
        position: "fixed",
        left: 0,
        top: 0,
        height: "100%",
        zIndex: 100,
        borderLeft: "1px solid  #EEEEEE",
        transition: "transform 450ms ease, width 450ms ease",
        overflowY: "auto",
        overflowX: "hidden",
        transform: "translateX(0)",
        /*      "&:hover": {
          width: "13.75rem",
        }, */
      }}
      className=" overflow-hidden"
    >
      <Box
        sx={{ borderBottom: "1px solid #e5e9f2", padding: "14px 22px" }}
        className="flex h-[50px] items-center justify-between"
      >
        {isMd ? (
          <MenuIcon
            sx={{
              color: (theme) =>
                theme.palette.mode === "light"
                  ? "rgba(179, 179, 184, 1)"
                  : "#fff",
              fontSize: "1.625rem",
              mr: 3,
              cursor: "pointer",
            }}
            onClick={() => {
              if (isMd) {
                setViewALl(!viewALl);
              } else {
                dispatch(openDrawer(false));
              }
            }}
          />
        ) : (
          <MenuIcon
            sx={{
              color: (theme) =>
                theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.81)" : "#fff",
              fontSize: "2em",
              mr: 1,
              cursor: "pointer",
            }}
            onClick={() => {
              dispatch(openDrawer(false));
            }}
          />
        )}
        <Box
          sx={{
            background: (theme) =>
              theme.palette.mode === "light" ? "#f0f2f5" : "#1a2935",
          }}
          className="flex md:hidden mx-5 gap-2 rounded-3xl py-2 px-3"
        >
        
          <span className="text-xs">
            {moment(new Date(), "YYYY-MM-DD HH:mm:ss").format("dddd")}
          </span>
          <span className="text-xs">
            {" "}
            {new Intl.DateTimeFormat("fa-IR", {
              month: "short",
              day: "numeric",
            }).format(new Date())}
          </span>
        </Box>
        <a href={process.env.REACT_APP_DOMAIN_URL} target="_blank" rel="noreferrer"> 
          <div className="flex items-center gap-3">
            {dark ? (
              <img
                src={`${baseUrl}/${DOWNLOAD_FILE}/${companyInfo?.companyDarkLogo}`}
                alt="logo"
                style={styles.logo}
                height={20}
              />
            ) : (
              <img
                src={`${baseUrl}/${DOWNLOAD_FILE}/${companyInfo?.companyLogo}`}
                alt="logo"
                style={styles.logo}
                height={20}
              />
            )}

            {/*    <span className="text-xs text-[#000]"> تحلیل موبایل</span> */}
          </div>
        </a>
      </Box>
      {!isMd && (
        <div className="flex justify-between  items-center gap-2 pr-6 pt-2 border-b pb-3">
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center md:w-[30px] md:h-[30px] w-[25px] h-[25px] rounded-full border-2 border-[#a1a3a8]">
              <PersonOutlineIcon sx={{ fontSize: "20px" }} />
            </div>

            <div className="flex flex-col gap-1 w-full pl-7 pr-3 ">
              <div className="flex items-center gap-2">
                <Typography
                  sx={{
                    fontSize: { xs: "14px !important" },
                  }}
                >
                  {userInfo?.fname} {userInfo?.lname}
                </Typography>
              </div>{" "}
              <Typography
                sx={{
                  fontSize: { md: "0.8rem !important", xs: "1rem !important" },
                  color: (theme) =>
                    theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
                  fontWeight: 900,
                }}
              >
                {userInfo?.access || "ادمین"}
              </Typography>
            </div>
          </div>
          <DarkModeSwitch />
        </div>
      )}
      <Box
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
        sx={styles.innerBox}
        className="sidebar overflow-x-hidden"
      >
        <List sx={{ width: "100%" }}>
          {headerMenu.map((item, i) =>
            !item.subroutes ? (
              <Link key={i} to={item.path}>
                <ListItem
                  sx={{
                    ...styles.listItem,
                    "&:hover": {
                      ".MuiListItemIcon-root": {
                        color: (theme) =>
                          theme.palette.mode === "light"
                            ? "#001ee4"
                            : "#90caf9",
                      },
                      ".MuiListItemText-root": {
                        color: (theme) =>
                          theme.palette.mode === "light"
                            ? "#001ee4"
                            : "#90caf9",
                      },
                    },
                  }}
                  onClick={() => {
                    if (!isMd) {
                      dispatch(openDrawer(false));
                    }
                  }}
                >
                  <ListItemIcon
                    sx={{
                      ...styles.listItemIcon,
                      color: (theme) =>
                        `/${location.pathname.split("/")[1]}` === item.path
                          ? theme.palette.mode === "light"
                            ? "#001ee4"
                            : "#90caf9"
                          : theme.palette.mode === "light"
                          ? "rgba(162, 162, 168, 0.81)"
                          : "#fff",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    sx={{
                      ...styles.listItemText,
                      ".MuiTypography-root": {
                        fontSize: { md: "0.9rem !important" },
                        fontWeight: 500,
                      },

                      color: (theme) =>
                        `/${location.pathname.split("/")[1]}` === item.path
                          ? theme.palette.mode === "light"
                            ? "#001ee4"
                            : "#90caf9"
                          : theme.palette.mode === "light"
                          ? "rgba(0, 0, 0)"
                          : "#fff",
                    }}
                  />
                </ListItem>
              </Link>
            ) : (
              <DrawerListItem
                item={item}
                key={i}
                setIsOpen={setIsOpen}
                isOpen={isOpen}
                viewALl={hover ? hover : viewALl}
              />
            )
          )}
          <ListItem onClick={() => logout()} sx={styles.listItem}>
            <ListItemIcon sx={styles.listItemIcon}>
              <MeetingRoom />
            </ListItemIcon>
            <ListItemText
              primary="خروج"
              sx={{
                ...styles.listItemText,
                ".MuiTypography-root": {
                  fontSize: { md: "0.9rem !important" },
                  fontWeight: 500,
                },
              }}
            />
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};

export default Sidebar;
